var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c(
        "sweet-modal",
        {
          ref: "photosPreviewModal",
          staticClass: "photosPreviewModal",
          attrs: { width: "90%", "overlay-theme": "dark" },
          on: { close: _vm.closeModal },
        },
        [
          _c("div", [
            _c("h4", [
              _vm._v(_vm._s(_vm.selectedDrug && _vm.selectedDrug.title)),
            ]),
            _vm._v(" "),
            _vm.selectedDrugId
              ? _c(
                  "div",
                  {
                    staticClass: "flex photoBlock",
                    staticStyle: { "margin-bottom": "20px" },
                  },
                  _vm._l(_vm.$AllProjects, function (project) {
                    return project.is_active
                      ? _c(
                          "div",
                          { key: project.id, staticClass: "project_block" },
                          [
                            _c(
                              "div",
                              [
                                _c("h4", [_vm._v(_vm._s(project.name))]),
                                _vm._v(" "),
                                _vm.photoData[project.id] &&
                                _vm.photoData[project.id][_vm.selectedDrugId] &&
                                _vm.photoData[project.id][_vm.selectedDrugId]
                                  .full
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex justify-content-between",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-sm btn-outline-primary",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.rotateImage(
                                                    project.id,
                                                    "left"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon-fa icon-fa-rotate-left",
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-sm btn-outline-primary",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.rotateImage(
                                                    project.id,
                                                    "right"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon-fa icon-fa-rotate-right",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("img", {
                                        attrs: {
                                          src:
                                            _vm.photoData[project.id][
                                              _vm.selectedDrugId
                                            ].full +
                                            "?v=" +
                                            _vm.todayTimestamp,
                                          alt: "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex flex-direction-column",
                                        },
                                        [
                                          _vm.photoData[project.id][
                                            _vm.selectedDrugId
                                          ].temp_photo == 1
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-sm btn-success",
                                                  staticStyle: {
                                                    "font-size": "13px",
                                                    "margin-bottom": "5px",
                                                    padding:
                                                      "5px 8px !important",
                                                  },
                                                  attrs: {
                                                    disabled:
                                                      _vm.actionLoading[
                                                        project.id
                                                      ].updateStatus,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.updateStatus(
                                                        project.id,
                                                        false
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm.actionLoading[project.id]
                                                    .updateStatus
                                                    ? [
                                                        _c("scale-loader", {
                                                          attrs: {
                                                            loading: true,
                                                            color: "white",
                                                            height: "12px",
                                                          },
                                                        }),
                                                      ]
                                                    : [
                                                        _vm._v(
                                                          "\n                    Сделать постоянным\n                  "
                                                        ),
                                                      ],
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.photoData[project.id][
                                            _vm.selectedDrugId
                                          ].temp_photo == 0
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-sm btn-success",
                                                  staticStyle: {
                                                    "font-size": "13px",
                                                    "margin-bottom": "5px",
                                                    padding:
                                                      "5px 8px !important",
                                                  },
                                                  attrs: {
                                                    disabled:
                                                      _vm.actionLoading[
                                                        project.id
                                                      ].updateStatus,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.updateStatus(
                                                        project.id,
                                                        true
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm.actionLoading[project.id]
                                                    .updateStatus
                                                    ? [
                                                        _c("scale-loader", {
                                                          attrs: {
                                                            loading: true,
                                                            color: "white",
                                                            height: "12px",
                                                          },
                                                        }),
                                                      ]
                                                    : [
                                                        _vm._v(
                                                          "\n                    Сделать временным\n                  "
                                                        ),
                                                      ],
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-sm btn-warning",
                                              staticStyle: {
                                                "font-size": "13px",
                                              },
                                              attrs: {
                                                disabled:
                                                  _vm.actionLoading[project.id]
                                                    .delete,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deletePhoto(
                                                    project.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm.actionLoading[project.id]
                                                .delete
                                                ? [
                                                    _c("scale-loader", {
                                                      attrs: {
                                                        loading: true,
                                                        color: "white",
                                                        height: "12px",
                                                      },
                                                    }),
                                                  ]
                                                : [
                                                    _vm._v(
                                                      "\n                    Удалить\n                  "
                                                    ),
                                                  ],
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ]
                                  : [
                                      _c("div", {
                                        staticClass: "no_image photo",
                                      }),
                                    ],
                                _vm._v(" "),
                                _vm.photoOptions.noRusPhoto.includes(project.id)
                                  ? _c(
                                      "label",
                                      {
                                        staticClass: "pointer",
                                        staticStyle: {
                                          "font-size": "13px",
                                          "margin-top": "8px",
                                        },
                                      },
                                      [
                                        _c("input", {
                                          staticStyle: {
                                            position: "relative",
                                            top: "3px",
                                          },
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked:
                                              _vm.photoData?.[project.id]?.[
                                                _vm.selectedDrugId
                                              ]?.no_rus_photo !== undefined &&
                                              _vm.photoData?.[project.id]?.[
                                                _vm.selectedDrugId
                                              ]?.no_rus_photo,
                                          },
                                          on: {
                                            change: function ($event) {
                                              _vm.noRusPhoto(
                                                project.id,
                                                !(
                                                  _vm.photoData?.[project.id]?.[
                                                    _vm.selectedDrugId
                                                  ]?.no_rus_photo !==
                                                    undefined &&
                                                  _vm.photoData?.[project.id]?.[
                                                    _vm.selectedDrugId
                                                  ]?.no_rus_photo
                                                )
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" \n              "),
                                        _vm.actionLoading[project.id]
                                          ?.noRusPhoto
                                          ? [
                                              _c("scale-loader", {
                                                attrs: {
                                                  loading: true,
                                                  color: "white",
                                                  height: "12px",
                                                },
                                              }),
                                            ]
                                          : _c("span", [
                                              _vm._v(
                                                "Невозможно найти русскоязычное фото"
                                              ),
                                            ]),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]
                        )
                      : _vm._e()
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _vm.uploadedImages
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-top": "28px",
                        "margin-bottom": "10px",
                      },
                    },
                    [
                      _c("h4", [_vm._v("Новые фотографии")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex justify-content-center" },
                        _vm._l(_vm.$AllProjects, function (project) {
                          return _vm.uploadedImages[project.id]
                            ? _c(
                                "div",
                                { key: project.id, staticClass: "no_image" },
                                [
                                  _vm.uploadedImages[project.id]
                                    ? [
                                        _c("h4", [
                                          _vm._v(_vm._s(project.name)),
                                        ]),
                                        _vm._v(" "),
                                        _c("img", {
                                          attrs: {
                                            src: _vm.uploadedImages[project.id]
                                              .url,
                                            alt: "",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-default",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeFromImagePull(
                                                  project.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "не выгружать на\n                  сайт\n                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.uploadedImages[
                                                      project.id
                                                    ].fileData.tempPhoto,
                                                  expression:
                                                    "uploadedImages[project.id].fileData.tempPhoto",
                                                },
                                              ],
                                              attrs: {
                                                type: "checkbox",
                                                id: `ch_temp_${project.id}`,
                                                disabled:
                                                  _vm.uploadedImages[project.id]
                                                    .fileData.mirrorId,
                                              },
                                              domProps: {
                                                checked: Array.isArray(
                                                  _vm.uploadedImages[project.id]
                                                    .fileData.tempPhoto
                                                )
                                                  ? _vm._i(
                                                      _vm.uploadedImages[
                                                        project.id
                                                      ].fileData.tempPhoto,
                                                      null
                                                    ) > -1
                                                  : _vm.uploadedImages[
                                                      project.id
                                                    ].fileData.tempPhoto,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$a =
                                                      _vm.uploadedImages[
                                                        project.id
                                                      ].fileData.tempPhoto,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          _vm.uploadedImages[
                                                            project.id
                                                          ].fileData,
                                                          "tempPhoto",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          _vm.uploadedImages[
                                                            project.id
                                                          ].fileData,
                                                          "tempPhoto",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      _vm.uploadedImages[
                                                        project.id
                                                      ].fileData,
                                                      "tempPhoto",
                                                      $$c
                                                    )
                                                  }
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "pointer",
                                                attrs: {
                                                  for: `ch_temp_${project.id}`,
                                                },
                                              },
                                              [_vm._v("Временное фото")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e()
                        }),
                        0
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                staticStyle: { display: "inline-block", "text-align": "left" },
              }),
              _vm._v(" "),
              _c("label", [
                _c(
                  "span",
                  { staticClass: "btn btn-info", attrs: { type: "button" } },
                  [
                    _vm._v("Выбрать фотографии\n          "),
                    _c("input", {
                      ref: "uploadFilesInput",
                      staticClass: "input-file hidden",
                      attrs: {
                        type: "file",
                        id: "uploadPhotos",
                        multiple: "",
                        disabled: _vm.isSaving,
                        accept: "image/*",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.filesAdded(
                            $event.target.name,
                            $event.target.files
                          )
                        },
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-success",
                  attrs: { type: "button", disabled: _vm.isSaving },
                  on: { click: _vm.upload },
                },
                [
                  _vm.isSaving
                    ? [
                        _c("scale-loader", {
                          attrs: {
                            loading: true,
                            color: "white",
                            height: "12px",
                          },
                        }),
                      ]
                    : [_vm._v("\n            Загрузить новые\n          ")],
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _vm.sitesRequirements.length
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      background: "#fff5e2",
                      padding: "15px",
                      "font-size": "12px",
                      "line-height": "151%",
                      "text-align": "left",
                      "max-width": "545px",
                      margin: "0 auto",
                      color: "#a68a54",
                      "border-radius": "3px",
                      display: "flex",
                      "justify-content": "space-between",
                    },
                  },
                  _vm._l(_vm.$AllProjects, function (project) {
                    return _vm.sitesRequirements[project.id] !== undefined
                      ? _c("div", { key: project.id }, [
                          _c("b", [_vm._v(_vm._s(project.name))]),
                          _vm._v(
                            ": " +
                              _vm._s(
                                _vm.sitesRequirements[project.id].image_ext
                              ) +
                              ",\n          " +
                              _vm._s(
                                _vm.sitesRequirements[project.id].images_width
                              ) +
                              "x" +
                              _vm._s(
                                _vm.sitesRequirements[project.id].images_height
                              ) +
                              "\n        "
                          ),
                        ])
                      : _vm._e()
                  }),
                  0
                )
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _vm.loading
            ? _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c("pulse-loader", {
                    staticClass: "text-center",
                    attrs: { loading: true, color: _vm.loadingColor },
                  }),
                ],
                1
              )
            : _c("div", { staticClass: "table-block" }, [
                _c("div", [
                  _c("div", { staticClass: "form-group m-0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.showFilter.tempPhoto,
                          expression: "showFilter.tempPhoto",
                        },
                      ],
                      attrs: { type: "checkbox", id: "ch_1" },
                      domProps: {
                        checked: Array.isArray(_vm.showFilter.tempPhoto)
                          ? _vm._i(_vm.showFilter.tempPhoto, null) > -1
                          : _vm.showFilter.tempPhoto,
                      },
                      on: {
                        change: [
                          function ($event) {
                            var $$a = _vm.showFilter.tempPhoto,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.showFilter,
                                    "tempPhoto",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.showFilter,
                                    "tempPhoto",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.showFilter, "tempPhoto", $$c)
                            }
                          },
                          _vm.updateView,
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "pointer", attrs: { for: "ch_1" } },
                      [_vm._v("Показать препараты с временными фото")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group m-0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.showFilter.inStore,
                          expression: "showFilter.inStore",
                        },
                      ],
                      attrs: { type: "checkbox", id: "ch_2" },
                      domProps: {
                        checked: Array.isArray(_vm.showFilter.inStore)
                          ? _vm._i(_vm.showFilter.inStore, null) > -1
                          : _vm.showFilter.inStore,
                      },
                      on: {
                        change: [
                          function ($event) {
                            var $$a = _vm.showFilter.inStore,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.showFilter,
                                    "inStore",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.showFilter,
                                    "inStore",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.showFilter, "inStore", $$c)
                            }
                          },
                          _vm.updateView,
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "pointer", attrs: { for: "ch_2" } },
                      [_vm._v("Показать препараты в наличии на МСК")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group m-0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.showFilter.withComments,
                          expression: "showFilter.withComments",
                        },
                      ],
                      attrs: { type: "checkbox", id: "ch_3" },
                      domProps: {
                        checked: Array.isArray(_vm.showFilter.withComments)
                          ? _vm._i(_vm.showFilter.withComments, null) > -1
                          : _vm.showFilter.withComments,
                      },
                      on: {
                        change: [
                          function ($event) {
                            var $$a = _vm.showFilter.withComments,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.showFilter,
                                    "withComments",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.showFilter,
                                    "withComments",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.showFilter, "withComments", $$c)
                            }
                          },
                          _vm.updateView,
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "pointer", attrs: { for: "ch_3" } },
                      [_vm._v("Показать препараты с комментариями")]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex" }, [
                  _c("div", { staticClass: "m-r-10" }, [
                    _c(
                      "button",
                      {
                        class: {
                          "btn btn-outline-primary": true,
                          active: _vm.filter[1],
                        },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.updateFilter(1)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "icon-fa icon-fa-check-circle color_green align-bottom",
                        }),
                        _vm._v(" - Фото загружено\n            "),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "m-r-10" }, [
                    _c(
                      "button",
                      {
                        class: {
                          "btn btn-outline-primary": true,
                          active: _vm.filter[2],
                        },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.updateFilter(2)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "icon-fa icon-fa-check-circle color_gray align-bottom",
                        }),
                        _vm._v(" - Временное фото\n            "),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "m-r-10" }, [
                    _c(
                      "button",
                      {
                        class: {
                          "btn btn-outline-primary": true,
                          active: _vm.filter[3],
                        },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.updateFilter(3)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "icon-fa icon-fa-times-circle color_red align-bottom",
                        }),
                        _vm._v(" - Фото отсутствует\n            "),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "m-r-10" }, [
                    _c(
                      "button",
                      {
                        class: {
                          "btn btn-outline-primary": true,
                          active: _vm.filter[4],
                        },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.updateFilter(4)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "icon-fa icon-fa-pause-circle color_yellow align-bottom",
                        }),
                        _vm._v(
                          " - Препарат отсутствует или\n              выключен\n            "
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "m-t-10" }, [
                  _vm._v("\n          всего записей: "),
                  _c("strong", [_vm._v(_vm._s(_vm.localDrugs.length))]),
                ]),
                _vm._v(" "),
                _vm.loadingTable
                  ? _c(
                      "div",
                      [
                        _c("pulse-loader", {
                          staticClass: "text-center",
                          attrs: { loading: true, color: _vm.loadingColor },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _c(
                          "table-component",
                          {
                            attrs: {
                              data: _vm.localDrugs,
                              "filter-placeholder": "Поиск препарата",
                              "sort-by": "title",
                              "sort-order": "asc",
                              "table-class": "table table-hover table-sm",
                            },
                          },
                          [
                            _c("table-column", {
                              attrs: {
                                show: "id",
                                sortable: true,
                                label: "ID",
                              },
                            }),
                            _vm._v(" "),
                            _c("table-column", {
                              attrs: { label: "Препарат" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (row) {
                                    return [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(row.title) +
                                          "\n                "
                                      ),
                                      _c(
                                        "div",
                                        [
                                          _vm._l(
                                            row.internal_comments || [],
                                            function (comment, index) {
                                              return [
                                                comment.comment_type === 1
                                                  ? _c("div", [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-right",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              comment.text
                                                            ) +
                                                              "\n                        "
                                                          ),
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn-outline-danger btn-xs",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.removeComment(
                                                                      row.id,
                                                                      index
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v("х")]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-right text-muted fs-11",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              comment.user_name
                                                            ) +
                                                              " : " +
                                                              _vm._s(
                                                                comment.date
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            }
                                          ),
                                          _vm._v(" "),
                                          !_vm.addComment[row.id]
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-xs btn-outline-info",
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.addComment[row.id] =
                                                        !_vm.addComment[row.id]
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "добавить комментарий\n                  "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.addComment[row.id]
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "input-group mb-1",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.newComment[
                                                            row.id
                                                          ],
                                                        expression:
                                                          "newComment[row.id]",
                                                      },
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      placeholder:
                                                        "Комментарий к препарату",
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.newComment[row.id],
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.newComment,
                                                          row.id,
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-append",
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn-success btn-sm",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.updateDrug(
                                                                row
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "icon-fa icon-fa-save",
                                                            staticStyle: {
                                                              "font-size":
                                                                "14px",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("table-column", {
                              attrs: { sortable: false, label: "Фотографии" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (row) {
                                    return [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-sm btn-info",
                                          on: {
                                            click: function ($event) {
                                              return _vm.getPhotos(row)
                                            },
                                          },
                                        },
                                        [_vm._v("Просмотр")]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.$AllProjects, function (project) {
                              return project.is_active
                                ? [
                                    _c("table-column", {
                                      key: project.id,
                                      attrs: {
                                        sortable: false,
                                        label: project.name,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (row) {
                                              return [
                                                _vm.photoData[project.id] &&
                                                _vm.photoData[project.id][
                                                  row.id
                                                ] &&
                                                _vm.photoData[project.id][
                                                  row.id
                                                ].status === 1
                                                  ? [
                                                      _c("i", {
                                                        class: {
                                                          "icon-fa icon-fa-check-circle":
                                                            !!_vm.photoData[
                                                              project.id
                                                            ][row.id].full,
                                                          color_green:
                                                            _vm.photoData[
                                                              project.id
                                                            ][row.id].full &&
                                                            _vm.photoData[
                                                              project.id
                                                            ][row.id]
                                                              .temp_photo == 0,
                                                          color_gray:
                                                            _vm.photoData[
                                                              project.id
                                                            ][row.id].full &&
                                                            _vm.photoData[
                                                              project.id
                                                            ][row.id]
                                                              .temp_photo == 1,
                                                          "icon-fa icon-fa-times-circle color_red":
                                                            !_vm.photoData[
                                                              project.id
                                                            ][row.id].full,
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: _vm.photoData[
                                                              project.id
                                                            ][row.id].url,
                                                            target: "_blank",
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "icon-fa icon-fa-external-link",
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  : [
                                                      _c("i", {
                                                        staticClass:
                                                          "icon-fa icon-fa-pause-circle color_yellow",
                                                      }),
                                                    ],
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ]
                                : _vm._e()
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
              ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h4", [_vm._v("Контроль фотографий")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }